
// press-section-js
document.addEventListener("DOMContentLoaded", function(){

    const SLIDE_DURATION = 4000;

    const section=document.querySelector('#pressSection');

    if(!section) return;

    const logos=section.querySelectorAll('.logo-item');

    const quotes=section.querySelectorAll('.quote-item');

    if(!logos.length) return;

    let currentIndex=0;
    let autoTimer=null;

    document.documentElement.style.setProperty(
    '--slide-duration',
    SLIDE_DURATION+'ms'
    );

    function setActive(index){

    logos.forEach(el=>el.classList.remove('active'));

    quotes.forEach(el=>el.classList.remove('active'));

    logos[index]?.classList.add('active');

    quotes[index]?.classList.add('active');

    currentIndex=index;

    }

    function goNext(){

    const next=(currentIndex+1)%logos.length;

    setActive(next);

    }

    function startAuto(){

    clearInterval(autoTimer);

    autoTimer=setInterval(
    goNext,
    SLIDE_DURATION
    );

    }

    logos.forEach((logo,index)=>{

    logo.addEventListener('click',()=>{

    setActive(index);

    startAuto();

    });

    });

    setActive(0);

    startAuto();

});

// banner js

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.new-re-banner .banner-video').forEach(video => {
    video.addEventListener('playing', function () {
      console.log('VIDEO PLAYING');

      document.querySelector('.banner-poster')
        ?.classList.add('loaded');
    });
  });
});

// product collection section

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.cu-slider').forEach(section => {

    const swiperEl = section.querySelector('.productSwiper');
    const nextBtn = section.querySelector('#btnNext');
    const prevBtn = section.querySelector('#btnPrev');

    if (swiperEl && window.innerWidth > 767) {
      new Swiper(swiperEl, {
        slidesPerView: 4,

        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },

        breakpoints: {
          0: {
            slidesPerView: 1,
          },
           575: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 2
          },
          991: {
            slidesPerView: 3
          },
          1200: {
            slidesPerView: 4
          }
        }
      });
    }

    section.querySelectorAll('.product-card').forEach(card => {

      const mainImage = card.querySelector('.main-product-image');
      const hoverImage = card.querySelector('.card-img.hover');

      card.querySelectorAll('.swatch').forEach(swatch => {

          swatch.addEventListener('mouseenter', function () {

            const image = this.dataset.image;

            if (image) {
                if (mainImage) {
                    mainImage.src = image;
                }

                if (hoverImage) {
                    hoverImage.src = image;
                }
            }

            card.querySelectorAll('.swatch').forEach(item => {
                item.classList.remove('active');
            });

            this.classList.add('active');

          });

      });

    });

  });

});

// review-slider

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.new-homereview').forEach(section => {

    function equalHeights() {
      let max = 0;

      section.querySelectorAll('.review_content').forEach(el => {
        el.style.height = 'auto';
        max = Math.max(max, el.offsetHeight);
      });

      section.querySelectorAll('.review_content').forEach(el => {
        el.style.height = max + 'px';
      });
    }

    new Swiper(section.querySelector('.review_slider_grid'), {
      loop: true,
      grabCursor: true,

      navigation: {
        nextEl: section.querySelector('.review-btn-next'),
        prevEl: section.querySelector('.review-btn-prev'),
      },

      pagination: {
        el: section.querySelector('.review-dots'),
        clickable: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: false,
        },

        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          centeredSlides: false,
        },

        1199: {
          slidesPerView: 3,
          spaceBetween: 30,
          centeredSlides: true,
        },

        1440: {
          slidesPerView: 3,
          spaceBetween: 50,
          centeredSlides: true,
        }
      },

      on: {
        init: equalHeights,
        resize: equalHeights,
        slideChange: equalHeights,
      }
    });

  });

});


document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.green-round, .title-circle-wrap');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('in-view');
        }, 300); // delay before animating in
      } else {
        entry.target.classList.remove('in-view'); // reset when out of view
      }
    });
  }, {
    threshold: 0.5
  });

  elements.forEach(el => observer.observe(el));
});




document.addEventListener("click", function (e) {
  const filterBtn = e.target.closest(".collection-filters-toggle .filter-box");

  if (!filterBtn) return;

  e.preventDefault();

  const container = document.querySelector("#ProductGridContainer");
  if (container) {
    container.classList.toggle("show-filter");
  }
});


// new faq section
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(".new-faq-section .faq-question").forEach((button) => {
        button.addEventListener("click", () => {
          const item = button.parentElement;
          const icon = button.querySelector(".icon");
          item.classList.toggle("active");
        });
      });
});

// 23june

document.addEventListener('DOMContentLoaded',() =>{
    new Swiper(".mobile-gallery", {
          spaceBetween: 10,
          slidesPerView: 1,

          breakpoints: {
            576: {
              slidesPerView: 2,
            },
          },

          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
    });
});



$(document).on('click', '.pbm-product .swatch', function () {

    var image = $(this).attr('data-variant-img');
    var srcset = $(this).attr('data-variant-srcset');
    var inventory_policy = $(this).attr('data-inventorypolicy'); 
    var inventory_count = $(this).attr('data-inventory-count');

    const $img = $(this)
        .closest('.pbm-product')
        .find('.popup-product-img');

    $img.attr('src', image);
    $img.attr('srcset', srcset);

    $(this)
        .closest('.product_tab_variants')
        .find('.swatch')
        .removeClass('active');

    $(this).addClass('active');

    if(inventory_policy == 'deny' && inventory_count <= 0){
      $(this).closest('.pbm-product').find('.pdp-atc-set .pbm-btn').attr('disabled', true);
      $(this).closest('.pbm-product').find('.pdp-atc-set .pbm-btn').text('Sold Out');
    }else{
      $(this).closest('.pbm-product').find('.pdp-atc-set .pbm-btn').attr('disabled', false);
      $(this).closest('.pbm-product').find('.pdp-atc-set .pbm-btn').text('Add to Cart');
    }

});

$(document).on('mouseenter', '.pbm-product .swatch', function () {

    var image = $(this).attr('data-variant-img');
    var srcset = $(this).attr('data-variant-srcset');
    var inventory_policy = $(this).attr('data-inventorypolicy'); 
    var inventory_count = $(this).attr('data-inventory-count');

    const $img = $(this)
        .closest('.pbm-product')
        .find('.popup-product-img');

    $img.attr('src', image);
    $img.attr('srcset', srcset);

    if(inventory_policy == 'deny' && inventory_count <= 0){
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').attr('disabled', true);
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').text('Sold Out');
    }else{
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').attr('disabled', false);
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').text('Add to Cart');
    }
});



$(document).on('mouseenter', '.pdp-complete-set .card-swatches .swatch', function () {

  var image = $(this).attr('data-variant-img');
  var srcset = $(this).attr('data-variant-srcset');
  var vid = $(this).attr('data-variant-id');
  var inventory_policy = $(this).attr('data-inventorypolicy'); 
  var inventory_count = $(this).attr('data-inventory-count');

  $(this).siblings().removeClass('active');
  $(this).addClass('active');

  const $img = $(this)
      .closest('.pdp-complete-set')
      .find('.popup-product-img');

  const $btn = $(this).closest('.pdp-complete-set').find('.pdp-atc-set .pbm-btn');

  $img.attr('src', image);
  $img.attr('srcset', srcset);

  if($btn){
    $btn.attr('data-variant-id', vid);

    if(inventory_policy == 'deny' && inventory_count <= 0){
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').attr('disabled', true);
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').text('Sold Out');
    }else{
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').attr('disabled', false);
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').text('Add to Cart');
    }
  }

});


$(document).on('mouseenter', '.pbm-wrap .card-swatches .swatch', function () {

  var image = $(this).attr('data-variant-img');
  var srcset = $(this).attr('data-variant-srcset');
  var vid = $(this).attr('data-variant-id');
  var inventory_policy = $(this).attr('data-inventorypolicy'); 
  var inventory_count = $(this).attr('data-inventory-count');

  $(this).siblings().removeClass('active');
  $(this).addClass('active');

  const $img = $(this)
      .closest('.pbm-wrap')
      .find('.popup-product-img');

  const $btn = $(this).closest('.pbm-wrap').find('.pdp-atc-set .pbm-btn');

  $img.attr('src', image);
  $img.attr('srcset', srcset);

  if($btn){
    $btn.attr('data-variant-id', vid);
    
    if(inventory_policy == 'deny' && inventory_count <= 0){
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').attr('disabled', true);
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').text('Sold Out');
    }else{
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').attr('disabled', false);
      $(this).closest('.pdp-card-wrapper').find('.pdp-atc-set .pbm-btn').text('Add to Cart');
    }
  }

});


$(document).on('mouseenter', '.pdp-cro-complete-set .pcard-swatches .swatch', function () {

  var image = $(this).attr('data-variant-img');
  var srcset = $(this).attr('data-variant-srcset');
  var vid = $(this).attr('data-variant-id');
  var inventory_policy = $(this).attr('data-inventorypolicy'); 
  var inventory_count = $(this).attr('data-inventory-count');

  $(this).siblings().removeClass('active');
  $(this).addClass('active');

  const $img = $(this)
      .closest('.pcard')
      .find('.popup-product-img');

  const $btn = $(this).closest('.pcard').find('.pcard-atc-grid .pcard-atc-button');

  $img.attr('src', image);
  $img.attr('srcset', srcset);

  if($btn){
    $btn.attr('data-selected-variant', vid);

    if(inventory_policy == 'deny' && inventory_count <= 0){
      $(this).closest('.pcard').find('.pcard-atc-grid .pcard-atc-button').attr('disabled', true);
      $(this).closest('.pcard').find('.pcard-atc-grid .pcard-atc-button').text('Sold Out');
    }else{
      $(this).closest('.pcard').find('.pcard-atc-grid .pcard-atc-button').attr('disabled', false);
      $(this).closest('.pcard').find('.pcard-atc-grid .pcard-atc-button').text('Add to Cart');
    }
  }

});


// 3 july

// document.addEventListener('DOMContentLoaded', function () {
//     document.querySelectorAll('.accordion-item-trigger-2').forEach(function(item) {
//         item.addEventListener('click', function() {
//             this.closest('.accordion-wrapper').classList.toggle('active_accd');

//             console.log('clicked');
//         });
//     });
// });